import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '../src/styles/variables.css'
import './index.css'
import App from './App.jsx'
import './index.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/fonts/Poppins-SemiBold.ttf'
import './assets/fonts/Poppins-Medium.ttf'
import './assets/fonts/Poppins-Regular.ttf'
import './i18n'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
